<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.reminders'), $t('text.list')]">
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.keyword"
            :placeholder="$t('text.serialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <el-select
            size="small"
            v-model="searchForm.supplierId"
            filterable
            clearable
            :placeholder="$t('menu.suppliers')"
          >
            <el-option
              v-for="supplier in suppliers"
              :key="supplier.id"
              :label="supplier.name"
              :value="supplier.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="flag" :title="$t('text.flag')" width="50">
          <template v-slot="{ row }">
            <span v-if="row.purcahse.flags != null && row.purcahse.flags != ''">
              <flag
                v-for="flag of JSON.parse(row.purcahse.flags).sort()"
                :key="flag"
                :name="flag"
              />
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.purcahse.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('text.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <small v-if="row.purcahse.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            <span class="blue" @click="showRow(row.purcahse)">
              {{ row.purcahse.serialNo }}
            </span>
            <div>
              <state-label :state="row.purcahse.workflowState">
                {{ $t("purchaseStates." + row.purcahse.workflowState) }}
              </state-label>
            </div>
            <div v-if="row.purcahse.settleAt != null" class="green font10">
              {{ $t("purchase.settlement") }}:{{ row.purcahse.settleAt }}
            </div>
            <div
              v-if="row.purcahse.manualSettleAt != null"
              class="orange font10"
            >
              {{ $t("purchase.manualSettle") }}:
              {{ row.purcahse.manualSettleAt }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="purcahse.supplierName"
          :title="$t('menu.suppliers')"
          min-width="80"
        />
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.purcahse.productNo }}
            <small
              v-if="
                row.purcahse.customerProductNo != null &&
                row.purcahse.customerProductNo != ''
              "
            >
              ({{ row.purcahse.customerProductNo }})
            </small>
            <div class="font10">
              {{ row.purcahse.categoryName }}
              <span v-if="row.purcahse.productBrand != null">/</span>
              {{ row.purcahse.productBrand }}
            </div>
            <div class="font10">
              {{ row.purcahse.color }} {{ row.purcahse.size }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.purcahse.quantity }}{{ row.purcahse.unit }}
            <div
              v-if="
                row.purcahse.receiveQuantity != null &&
                row.purcahse.receiveQuantity != 0
              "
              class="font10"
            >
              {{ $t("purchase.receive") }}: {{ row.purcahse.receiveQuantity
              }}{{ row.purcahse.unit }}
            </div>
            <div
              v-if="
                row.purcahse.qualityQuantity != null &&
                row.purcahse.qualityQuantity != 0
              "
              class="font10"
            >
              {{ $t("purchase.qualityQuantity") }}:{{
                row.purcahse.qualityQuantity
              }}{{ row.purcahse.unit }}
            </div>
            <div
              v-if="
                row.purcahse.reworkQuantity != null &&
                row.purcahse.reworkQuantity != 0
              "
              class="font10"
            >
              {{ $t("purchase.reworkQuantity") }}:{{
                row.purcahse.reworkQuantity
              }}{{ row.purcahse.unit }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="purcahse.giveAt"
          :title="$t('purchase.giveAt')"
          min-width="110"
        />
        <vxe-table-column
          field="purcahse.handOverAt"
          :title="$t('text.handOverAt')"
          min-width="110"
        />
        <vxe-table-column
          field="purcahse.remark"
          :title="$t('text.remark')"
          min-width="60"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.purcahse.remark"
              :number="6"
              type="richText"
            />
            <div>
              <attribute :content="row.purcahse.specJson" :number="6" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('reminder.remark')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number
              :content="row.remark"
              :number="6"
              type="richText"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createdAt"
          :title="$t('reminder.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="readAt"
          :title="$t('reminder.readAt')"
          min-width="110"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import RawHtml from "@/components/RawHtml";
import Util from "@/utils/index.js";

import Show from "@/views/pms/purchases/show";

import Supplier from "@/api/supplier.js";
import Reminder from "@/api/reminder.js";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtml,
    DateRange,
    Show,
  },
  data() {
    return {
      Util: Util,

      narrows: [
        [
          {
            label: this.$t("notice.readInfo"),
            items: [
              {
                label: this.$t("notice.readed"),
                key: "readYes",
                condition: { read: "yes" },
              },
              {
                label: this.$t("notice.unRead"),
                key: "readNo",
                condition: { read: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "readNo",
      searchForm: {
        keyword: null,
        productNo: null,
        supplierId: null,
      },
      sorter: {
        sortBy: "reminders_id",
        sortIndicator: "desc",
      },
      suppliers: [],

      //
      currentRowId: null,
      showDF: false,
      //
      currentRowIdx: null,
    };
  },
  computed: {
    implicit() {
      return {
        type: "reminde",
      };
    },
  },
  created() {
    const self = this;
    self.loadingStart();
    Supplier.findByTenantId(self.Permit.currentTenant().id).then(function (
      res
    ) {
      if (res.status === 200) {
        self.suppliers = res.data;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {
    //
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    //
    dataProvider(params) {
      return Reminder.search(params);
    },
  },
};
</script>
